import React, { useContext, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Start from "./Start";
// import Checklist from "./checklist";
import Checklist from "./creatorChecklist";
import BrandChecklist from "./brandChecklist";
import { useNavigationBar } from "../../context/NavigationContext";
import { CreateChannelContext } from "../../context/CreateChannelContext";
import LoadingPopup from "../channels/create/LoadingPopup";
import { ChannelType } from "../../models/SKChannel";
import ChannelApplication from "./creatorChecklist/channelApplication";

const Onboarding = () => {
  const navigate = useNavigate();
  const navContext = useNavigationBar();
  const { channelData, loading } = useContext(CreateChannelContext);

  useEffect(() => {
    if (channelData && channelData.id) {
      navigate("../onboarding");
    }
  }, [channelData]);

  return loading ? (
    <LoadingPopup isLoading={true} loadingText="Loading" />
  ) : (
    <div className="relative">
      {/* <div className="flex-1 clear-start"> */}
      <div className="absolute left-0 flex flex-col w-full h-screen overflow-y-auto" style={{ height: `calc(100vh - 144px)` }}>
        <Routes>
          <Route path="/" element={<Checklist />} />
          {/* <Route path="/checklist" element={<Checklist />} /> */}
          <Route path="/application" element={<ChannelApplication />} />
          <Route path="/brand-checklist" element={<BrandChecklist />} />
        </Routes>
      </div>
    </div>
  );
};

export default Onboarding;
